import { formatDustMonitorCardNumber } from "@/helpers/cardNumbers";
import type {
  DustMonitorCard,
  DustMonitorCardVeeRow,
  DustMonitorCardVeeUpdate,
} from "@/views/dustMonitorCard/dustMonitorCard";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  toVeeRow,
  toVeeUpdate,
  fullName,
};

function addAuthRequestFields(entity: DustMonitorCard) {
  entity._authRequestFields = ["id"];
  return entity;
}

function getInitialData() {
  const result = {} as DustMonitorCard;
  return addAuthRequestFields(result);
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: DustMonitorCard }) {
  addAuthRequestFields(response.data);
  response.data.number = formatDustMonitorCardNumber(response.data.number);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: DustMonitorCard }) {
  await skinnyResponseAdapter(response);
  return response.data;
}

function fullName(card: DustMonitorCard) {
  return [card.firstName, card.middleInitial, card.lastName].filter(Boolean).join(" ");
}

/** Flattens a card into the shape the Update VEE form binds to. An unanswered flag stays null so it reads as unknown. */
function toVeeRow(card: DustMonitorCard): DustMonitorCardVeeRow {
  return {
    id: card.id,
    name: fullName(card),
    email: card.email ?? "",
    number: formatDustMonitorCardNumber(card.number),
    hasAttendedVee: card.hasAttendedVee ?? null,
    hasPassedVee: card.hasPassedVee ?? null,
  };
}

/** Strips the display-only fields back off a VEE row for the batch PUT. */
function toVeeUpdate(row: DustMonitorCardVeeRow): DustMonitorCardVeeUpdate {
  return {
    id: row.id,
    hasAttendedVee: row.hasAttendedVee ?? null,
    hasPassedVee: row.hasPassedVee ?? null,
  };
}
